import React from "react";
import { Link } from "react-router-dom";

const DataTreatmentPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-12">
      <div className="max-w-3xl mx-auto space-y-6">
        <Link to="/" className="text-blue-600 hover:text-blue-800 text-sm">
          ← Volver
        </Link>

        <h1 className="text-3xl font-bold">
          Autorización de Tratamiento de Datos Personales
        </h1>
        <p className="text-sm text-gray-500">
          Última actualización: 23 de agosto de 2026
        </p>

        <p>
          Al marcar la casilla de aceptación en el registro o en el aviso
          correspondiente dentro de la Plataforma, usted, en calidad de
          titular de datos personales, otorga autorización previa, expresa e
          informada a CREATIMATICA S.A.S. (NIT 902037926-7), responsable del
          tratamiento, para lo siguiente:
        </p>

        <h2 className="text-xl font-semibold mt-8">
          1. Autorización otorgada
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Recolectar, almacenar, usar, circular, procesar y suprimir sus
            datos personales de identificación, contacto, laborales y
            operativos, conforme a las finalidades descritas en la Política
            de Tratamiento de Datos Personales.
          </li>
          <li>
            Tratar de manera excepcional los datos sensibles que usted decida
            suministrar voluntariamente (grupo sanguíneo, contacto de
            emergencia, fecha de nacimiento), únicamente para los fines allí
            descritos.
          </li>
          <li>
            Compartir la información estrictamente necesaria con los
            encargados del tratamiento (proveedores de infraestructura,
            mensajería, inteligencia artificial y correo electrónico)
            descritos en la Política de Tratamiento de Datos Personales,
            incluyendo transferencias internacionales cuando el proveedor
            opere fuera de Colombia.
          </li>
          <li>
            Enviar comunicaciones operativas, de soporte y, cuando
            corresponda, comerciales, a través de correo electrónico y
            notificaciones push.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">
          2. Carácter de la autorización
        </h2>
        <p>
          Esta autorización es libre, previa, expresa e informada. El
          suministro de datos sensibles es facultativo; su negativa no afecta
          el acceso a las funcionalidades esenciales de la Plataforma.
        </p>

        <h2 className="text-xl font-semibold mt-8">
          3. Consecuencia de no otorgar la autorización
        </h2>
        <p>
          Si el titular no otorga esta autorización, CREATIMATICA S.A.S. no
          podrá crear ni administrar su cuenta de usuario, por lo que no será
          posible acceder a la Plataforma.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Vigencia</h2>
        <p>
          Esta autorización estará vigente durante el tiempo en que se
          mantenga la relación contractual y durante el término posterior
          necesario para el cumplimiento de obligaciones legales, o hasta que
          el titular ejerza su derecho de revocatoria conforme al
          procedimiento descrito en la Política de Tratamiento de Datos
          Personales.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Revocatoria</h2>
        <p>
          El titular puede revocar esta autorización en cualquier momento
          escribiendo a{" "}
          <a
            href="mailto:previonix@gmail.com"
            className="text-blue-600 underline"
          >
            previonix@gmail.com
          </a>
          , sin perjuicio de las obligaciones legales que deban conservarse.
        </p>

        <p className="pt-4 font-medium">
          Al hacer clic en "Aceptar y continuar" o al marcar la casilla
          correspondiente durante el registro, usted declara haber leído y
          comprendido esta autorización, así como la Política de Tratamiento
          de Datos Personales, y otorga su consentimiento libre, expreso e
          informado.
        </p>

        <div className="pt-6">
          <Link
            to="/politica-privacidad"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            ← Ver Política de Tratamiento de Datos Personales
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DataTreatmentPage;
